<template>
  <div class="departments">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="showPopup = true" class="btn fixed_btn">
        New Department
      </button>
      <div class="card">
        <p class="title">Your Departments</p>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Code</th>
              <th>Control</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="departments.length">
              <template v-for="(item, i) in departments">
                <tr :key="i" :class="{ grey: i % 2 }">
                  <td data-label="Title">
                    <div class="img-text">
                      {{ item.name }}
                    </div>
                  </td>
                  <td data-label="Code">
                    <div class="img-text">
                      {{ item.code ? item.code : "N/A" }}
                    </div>
                  </td>
                  <td data-label="Edit">
                    <img
                      @click="handleEdit(item)"
                      class="action clickable"
                      style="margin-right: 5%"
                      src="@/assets/img/edit.svg"
                    />

                    <img
                      @click="handleDelete(item)"
                      class="action clickable"
                      src="@/assets/img/delete.svg"
                    />
                  </td>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr>
                <td>You have no departments</td>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="pagination">
          <div
            class="action prev"
            :class="{ inactive: !pagination.previous_doc }"
            @click="moveToPage(0)"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action prev"
            :class="{ inactive: !pagination.previous_doc }"
            @click="moveToPage(0)"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <!-- <div class="pages">
            <div class='action page active' >
              {{((pagination.current_page-1)*pagination.page_size)+1}}-{{pagination.current_page*pagination.page_size}} of {{usage[source+'s']}}
            </div>
          </div> -->
          <div
            class="action next"
            :class="{ inactive: !pagination.next_doc }"
            @click="moveToPage(1)"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action next"
            :class="{ inactive: !pagination.next_doc }"
            @click="moveToPage()"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
        </div>
      </div>
    </div>
    <popup>
      <template>
        <p class="title">Department</p>
        <div class="inputs survey-forms">
          <transition name="fade">
            <div class="full">
              <div class="input full">
                <label>Department Name <span>*</span></label>
                <input type="text" v-model="department.name" />
              </div>
              <div class="input full">
                <label>Department Code <span>*</span></label>
                <input type="text" v-model="department.code" />
              </div>
              <button @click="validate" class="btn round-btn">
                Save
              </button>
            </div>
          </transition>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import Popup from "@/components/Popup.vue";
import firebase from "firebase";
import Swal from "sweetalert2";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;

export default {
  components: {
    popup: Popup,
  },
  data() {
    return {
      details: null,
      department: {
        name: null,
        code: null,
        created_at: Date.now(),
      },
      source: "departments",
      departments: [],
      showPopup: false,
      pagination: {
        previous_doc: null,
        next_doc: null,
        page_size: 10,
        current_page: 1,
      },
    };
  },
  created() {
    return this.moveToPage(0);
  },
  methods: {
    moveToPage(page) {
      let pagination = this.pagination;
      let ref = db
        .collection("user")
        .doc(this.user_doc.id)
        .collection(this.source);
      if (this.filter_values) {
        for (const key in this.filter_values) {
          if (this.filter_values.hasOwnProperty(key) && this.filter_values) {
            const element = this.filter_values[key];
            if (element) {
              ref = ref.where(`${key}.id`, "==", element.id);
            }
          }
        }
      }
      if (page === -1) {
        //Previous Page
        ref = ref
          .limit(pagination.page_size)
          .orderBy("name", "desc")
          .startAfter(pagination.previous_doc);
      } else if (page === 1) {
        //Next Page
        ref = ref
          .limit(pagination.page_size)
          .orderBy("name")
          .startAfter(pagination.next_doc);
      } else if (page === 0) {
        //First page
        ref = ref.limit(pagination.page_size).orderBy("name");
      } else {
        //Last page
        let total = this.usage[this.source + "s"];
        let last_full_page = Math.floor(total / pagination.page_size);
        let limit = total - last_full_page * pagination.page_size;
        ref = ref.limit(limit || pagination.page_size).orderBy("name", "desc");
      }

      ref.onSnapshot((query) => {
        let docs = query.docs;

        if (page === -1 || page === undefined) {
          // counting down
          docs.reverse();
        }
        if (query.size === 0 && page !== 0) {
          if (page === 1) {
            this.pagination.next_doc = null;
          } else if (page === -1) {
            this.pagination.previous_doc = null;
          }
        } else {
          let departments = docs.map((d) =>
            Object.assign({ id: d.id }, d.data())
          );
          this.pagination.previous_doc = docs[0];
          this.pagination.next_doc = docs[docs.length - 1];
          if (page === 0) {
            this.pagination.previous_doc = null;
            this.pagination.current_page = 1;
            if (query.size < pagination.page_size) {
              this.pagination.next_doc = null;
            }
          } else if (page === undefined) {
            let total = this.usage[this.source];
            let last_full_page = Math.ceil(total / pagination.page_size);
            this.pagination.next_doc = null;
            this.pagination.current_page = last_full_page;
          } else {
            this.pagination.current_page += page;
            if (query.size < pagination.page_size) {
              this.pagination[page === -1 ? "previous_doc" : "next_doc"] = null;
            }
          }
          this.departments = departments;
        }
        this.pagination = Object.assign({}, this.pagination);
      });
      return true;
    },

    async addDepartment() {
      try {
        !this.department.id
          ? await db
              .collection("user")
              .doc(this.user_doc.id)
              .collection("departments")
              .add(this.department)
          : await db
              .collection("user")
              .doc(this.user_doc.id)
              .collection("departments")
              .doc(this.department.id)
              .set(this.department, { merge: true });
      } catch (error) {
        this.showPopup = false;
        return Swal.fire(
          "Error",
          "An Error has occured please try again later",
          "error"
        );
      }

      Swal.fire("Department has been saved");
      this.department = {
        name: null,
        code: null,
        created_at: Date.now(),
      };
      this.showPopup = false;
      return this.moveToPage(0);
    },
    validate() {
      let valid = true;
      for (const key in this.department) {
        if (!this.department[key]) valid = false;
      }

      if (valid) {
        this.addDepartment();
      } else {
        this.showPopup = false;
        Swal.fire(
          "warning",
          "Please fill in all required fields (*)",
          "warning"
        ).then(() => (this.showPopup = true));
      }
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL",
      }).then((result) => {
        if (result.value) {
          return db
            .collection("user")
            .doc(this.user_doc.id)
            .collection("departments")
            .doc(item.id)
            .delete()
            .then(() => {
              Swal.fire(
                "Deleted!",
                "The department has been deleted.",
                "success"
              );
            });
        }
      });
    },
    handleEdit(item) {
      this.department = item;
      this.showPopup = true;
    },
  },
};
</script>

<style lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    img {
      position: absolute;
      z-index: 0;
      opacity: 0.1;
      height: 80%;
      right: 10%;
      top: 50%;
      transform: translateY(-50%);
    }
    .stat {
      font-size: 80px;
      color: #49c6d4;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
}
</style>
